"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.weatherOptions = exports.weather = void 0;
exports.weather = [
    'Unknown or Not Given',
    'Clouds - Cloudy',
    'Clouds - Overcast',
    'Clouds - Partly Cloudy',
    'Fog - Fog',
    'Fog - Freezing Fog',
    'Fog - Mist',
    'Ice Pellets - Ice Pellets',
    'Ice Pellets - Light Showers of Ice Pellets',
    'Ice Pellets - Moderate or Heavy Showers of Ice Pellets',
    'Other - Indoor',
    'Other - Sunshine',
    'Other - Thundery Outbreaks Nearby',
    'Rain - Freezing Drizzle',
    'Rain - Heavy Freezing Drizzle',
    'Rain - Heavy Rain',
    'Rain - Heavy Rain at Times',
    'Rain - Light Drizzle',
    'Rain - Light Freezing Rain',
    'Rain - Light Rain',
    'Rain - Light Rain Shower',
    'Rain - Moderate or Heavy Freezing Rain',
    'Rain - Moderate or Heavy Rain in Area with Thunder',
    'Rain - Moderate or Heavy Rain Shower',
    'Rain - Moderate Rain',
    'Rain - Moderate Rain at Times',
    'Rain - Patchy Freezing Drizzle Nearby',
    'Rain - Patchy Light Drizzle',
    'Rain - Patchy Light Rain',
    'Rain - Patchy Light Rain in the Area with Thunder',
    'Rain - Patchy Rain Nearby',
    'Rain - Rain',
    'Rain - Showers',
    'Rain - Torrential Rain Shower',
    'Sleet - Light Sleet',
    'Sleet - Light Sleet Showers',
    'Sleet - Moderate or Heavy Sleet',
    'Sleet - Moderate or Heavy Sleet Showers',
    'Sleet - Patchy Sleet Nearby',
    'Snow - Blizzard',
    'Snow - Blowing Snow',
    'Snow - Heavy Snow',
    'Snow - Light Snow',
    'Snow - Light Snow Showers',
    'Snow - Moderate or Heavy Snow in the Area with Thunder',
    'Snow - Moderate or Heavy Snow Showers',
    'Snow - Moderate Snow',
    'Snow - Patchy Heavy Snow',
    'Snow - Patchy Light Snow',
    'Snow - Patchy Light Snow in Area with Thunder',
    'Snow - Patchy Moderate Snow',
    'Snow - Patchy Snow Nearby',
    'Snow - Snow',
];
exports.weatherOptions = new Set(exports.weather.map(function (option) { return ({
    text: option,
    value: option,
}); }));
